export default "__VITE_PUBLIC_ASSET__bf04b28d__"